import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import appR from './reducers/index';
import appSaga from './saga/index'
const sagaMiddleware = createSagaMiddleware();

const store = createStore(appR, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(appSaga);
export default store;